import { Directive, Input, OnChanges, SimpleChanges } from '@angular/core';
import { NG_VALIDATORS } from '@angular/forms';
import { BaseValidator } from '@tcm-modules/tcm-core.module';

@Directive({
    selector: '[lessThanOrEqualTo]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: LessThanOrEqualToValidator, multi: true }
    ],
    standalone: false
})
export class LessThanOrEqualToValidator extends BaseValidator implements OnChanges {

  @Input('lessThanOrEqualTo')
  otherValue: string;

  @Input()
  comparisonType: string;

  @Input()
  fieldName: string;

  @Input()
  errorMessage: string;

  constructor() {
    super('lessThanOrEqualTo');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.otherValue && changes.otherValue.isFirstChange()) {
      return;
    }

    this._onChange();
  }

  protected getValidationResult(control: any) {
    if (control.value == null || this.otherValue == null) {
      return null;
    }

    let firstValue: any = control.value;
    let secondValue: any = this.otherValue;
    if (this.comparisonType === "Date") {
      firstValue = new Date(control.value);
      secondValue = new Date(this.otherValue);
    }
    if (this.comparisonType === "SystemDate") {
      firstValue = control.value;
      secondValue = this.otherValue;
    }

    if (firstValue <= secondValue)
      return null;

    let validationResult = { 'lessThanOrEqualTo': { fieldName: this.fieldName, error: null } };

    if (this.errorMessage) {
      validationResult.lessThanOrEqualTo.error = this.errorMessage;
    }

    return validationResult;
  }
}
